import { render, staticRenderFns } from "./UsersShowAdmin.vue?vue&type=template&id=c8206fa4&scoped=true"
import script from "./UsersShowAdmin.vue?vue&type=script&lang=js"
export * from "./UsersShowAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8206fa4",
  null
  
)

export default component.exports